import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { COLLAPSED_DRAWER, FIXED_DRAWER, HORIZONTAL_NAVIGATION, INSIDE_THE_HEADER } from 'constants/ActionTypes';
import Notifications from './Notifications';
import { toggleCollapsedNav } from 'actions/Setting';
import UserInfo from 'components/UserInfo';
import Menu from './Menu';
import { userSignOut } from 'actions/Auth';

class Header extends React.Component {
	onAppNotificationSelect = () => {
		this.setState({
			appNotification: !this.state.appNotification
		});
	};

	onUserInfoSelect = () => {
		this.setState({
			userInfo: !this.state.userInfo
		});
	};

	onToggleCollapsedNav = e => {
		const val = !this.props.navCollapsed;
		this.props.toggleCollapsedNav(val);
	};

	constructor() {
		super();
		this.state = {
			appNotification: false,
			userInfo: false
		};
	}

	render() {
		const { drawerType, locale, navigationStyle, horizontalNavPosition } = this.props;
		const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'd-flex d-xl-none' : drawerType.includes(COLLAPSED_DRAWER) ? 'd-flex' : 'd-none';

		return (
			<div className="app-main-header">
				<div className="d-flex app-toolbar align-items-center">
					{navigationStyle === HORIZONTAL_NAVIGATION ? (
						<div className="app-logo-bl">
							<div className="d-block d-md-none">
								<span className="jr-menu-icon" onClick={this.onToggleCollapsedNav}>
									<span className="menu-icon bg-white" />
								</span>
							</div>
							<div className="app-logo pointer d-none d-md-block">
								<img className="d-none d-lg-block" alt="..." src="http://via.placeholder.com/105x36" />
								<img className="d-block d-lg-none mr-3" alt="..." src="http://via.placeholder.com/32x32" />
							</div>
						</div>
					) : (
						<span className={`jr-menu-icon pointer ${drawerStyle}`} onClick={this.onToggleCollapsedNav}>
							<span className="menu-icon bg-white" />
						</span>
					)}

					{navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === INSIDE_THE_HEADER && <Menu />}

					<ul className="header-notifications list-inline ml-auto">
						<li className="list-inline-item app-tour">
							<Dropdown className="quick-menu" isOpen={this.state.appNotification} toggle={this.onAppNotificationSelect.bind(this)}>
								<DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
									<span className="icon-btn size-20 font-size-16 text-white">
										<i className="zmdi zmdi-notifications-active zmdi-hc-lg" />
									</span>
								</DropdownToggle>

								<DropdownMenu right>
									<div className="jr-card-header d-flex align-items-center">
										<div className="mr-auto">
											<h3 className="card-heading">Benachrichtigungen</h3>
										</div>

										<span className="icon-btn size-30">
											<i className="zmdi zmdi-chevron-down" />
										</span>
									</div>
									<Notifications
										notifications={this.props.notifications}
										toReport={reportId => this.props.history.push(`/app/report/${reportId}`)}
									/>
								</DropdownMenu>
							</Dropdown>
						</li>
						<li className="list-inline-item user-nav">
							<Dropdown className="quick-menu" isOpen={this.state.userInfo} toggle={this.onUserInfoSelect.bind(this)}>
								<DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
									<span className="user-avatar bg-white border-0 size-40">
										<h3 className="m-0 text-primary text-uppercase">
											{`${this.props.userProfile.firstName.charAt(0)}${this.props.userProfile.lastName.charAt(0)}`}
										</h3>
									</span>
								</DropdownToggle>

								<DropdownMenu right>
									<UserInfo user={this.props.userProfile} onSignOut={() => this.props.userSignOut()} />
								</DropdownMenu>
							</Dropdown>
						</li>
					</ul>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ({ settings, general, auth }) => {
	const { drawerType, locale, navigationStyle, horizontalNavPosition } = settings;
	const { userProfile, notifications } = general;
	return { drawerType, locale, navigationStyle, horizontalNavPosition, userProfile, notifications };
};

export default withRouter(
	connect(
		mapStateToProps,
		{ toggleCollapsedNav, userSignOut }
	)(Header)
);



// WEBPACK FOOTER //
// ./containers/Header/index.js